export default {
  // 排班数据
  workerList: [],
  filterCity: {},
  filterArea: [],
  filterLevel: [],
  filterTime: '',
  filterService: [],
  starLevelsList: [],
  serviceTypeList: [],
  areaList: [],
  allWorkers: [],
  // 服务之星
  workerStars: []
}
